import httpClient from "@/api/http-client";
import AuthStore from '@/store/modules/AuthStore';
import ShirtSize from '@/components/admin/carreras/ShirtSize.vue';

const ENDPOINT = "/evento/carrera/precio";

export interface PrecioCreateDto {
  id?: number;
  nombre: string;
  descripcion: string;
  fechaVigencia?: Date | string | null;
  conCamiseta: boolean;
}

export interface PriceViewModel {
  id: number;
  precio: number;
  nombre: string;
  tipoDescriptor?: string;
  conCamiseta?: boolean;
}

export interface ShirtSizeViewModel {
  id: number;
  talla: { id: number, nombre: string };
}

class PrecioCarreraService {
  getAll(idCarrera: string): Promise<PrecioCreateDto[]> {
    return httpClient
      .get(`${ENDPOINT}/editable/${idCarrera}`)
      .then(response => {
        if (response.data) {
          return response.data;
        }
      });
  }
  save(idCarrera: string, createDto: PrecioCreateDto) {
    return httpClient.post(`${ENDPOINT}/editable/${idCarrera}`, createDto);
  }

  /**
   * We should pass this logic to backend :(
   */
  filterPricesAndOrderAsc(prices: PriceViewModel[]): any {
    let filtered: PriceViewModel[] = [];

    if (AuthStore.loggedIn) {
      filtered = prices.filter((p) => {
        return (p?.tipoDescriptor === "11" && AuthStore.isPersonaInMembrecia) ||
          (p.tipoDescriptor === "4" && AuthStore.getPersonaEdad >= 65) ||
          (p.tipoDescriptor === "2" && AuthStore.getCarnetConadis) ||
          (p.tipoDescriptor === "3" && AuthStore.getPersonaEdad < 12) ||
          (p.tipoDescriptor === "1");
      });
    }

    filtered = filtered.sort((a, b) => a.precio - b.precio);

    return filtered;
  }

  /**
   * We should pass this logic to backend :(
   * No nos pagan para esto, pero es necesario
   */
  filterPricesByShirtSize(prices: PriceViewModel[], shirtSize: ShirtSizeViewModel | any): any {
    const callback = shirtSize.talla.nombre != 'Sin Camiseta' //LOL
      ? (p: PriceViewModel) => p.conCamiseta
      : (p: PriceViewModel) => !p.conCamiseta;

    return prices.filter(callback);
  }
}

export default new PrecioCarreraService();
